import envServiceAPI from '@/api/modules/envAPI.js';
import { CookieUtil } from '@/helpers/cookie-util';
// 模块独立存储
const state = {
  userName: '',
  userId: '',
  userInfo: {},
  tenantList: [],
  tenantId: '',
};

// getters
const getters = {
  // 获取用户信息
  // eslint-disable-next-line no-shadow
  userInfo: state => state.userInfo,
  // eslint-disable-next-line no-shadow
  tenantList: state => state.tenantList,
};
const mutations = {
  // eslint-disable-next-line no-shadow
  SET_AUTH_INFO(state, data) {
    state.userName = data.userName;
    state.userId = data.userId;
    state.userInfo = data;
    // 检测租户环境
    envServiceAPI.checkEnvToReload();
    envServiceAPI.initEnvListener();
  },
  // eslint-disable-next-line no-shadow
  SET_ROUTER_KEY(state, tenantId) {
    console.log('SET_ROUTER_KEY')
    state.tenantId = tenantId;
    CookieUtil.set('routerKey', tenantId);
  },
  // eslint-disable-next-line no-shadow
  CLEAR_ROUTER_KEY(state) {
    console.log('CLEAR_ROUTER_KEY');
    state.tenantId = ''
    CookieUtil.set('routerKey', '');
  },
  // eslint-disable-next-line no-shadow
  SET_TENANT_LIST(state, data) {
    state.tenantList = data;
  },

  // eslint-disable-next-line no-shadow
  CLEAR_USER_STATE(state) {
    state.userName = '';
    state.userId = '';
    state.userInfo = {};
    state.tenantList = [];
    this.commit('auth/CLEAR_ROUTER_KEY');
  },
};
export default {
  namespaced: true,
  state,
  mutations,
  getters,
};
